export class QElemDragInfoObj {
  constructor() {
    this.fSrcPanel = null;
    this.fDstPanel = null;
    this.fReleaseCmd = null;
    this.fCallback = null;
    this.fEnabled = true;
    this.fShowDragSrcElem = false;
    this.fInstantDrag = false;
    this.fAllowedtargets = null;
    this.fStartCmd = null;
  }

  InitDragInfoObj(srcPanel, dstPanel, releaseCmd, startCmd) {
    this.fSrcPanel = srcPanel;
    this.fDstPanel = dstPanel;
    this.fReleaseCmd = releaseCmd;
    this.fStartCmd = startCmd;
  }

  EnableInstantDrag() {
    this.fInstantDrag = true;
  }

  GetInstantDrag() {
    return this.fInstantDrag;
  }

  ShowDragSourceElem() {
    this.fShowDragSrcElem = true;
  }

  GetShowDragSourceElem() {
    return this.fShowDragSrcElem;
  }

  GetDestinationPanel() {
    return this.fDstPanel;
  }

  GetSourcePanel() {
    return this.fSrcPanel;
  }

  GetReleaseCmd() {
    return this.fReleaseCmd;
  }

  GetStartCmd() {
    return this.fStartCmd;
  }

  GetHideTargetIndicator() {
    return this.fHideIndicator;
  }

  SetHideTargetIndicator(hideIndicator) {
    this.fHideIndicator = hideIndicator;
  }

  SetStartCmd(startCmd) {
    this.fStartCmd = startCmd;
  }

  SetCallback(callback) {
    this.fCallback = callback;
  }

  GetAllowedTargets() {
    return this.fAllowedTargets;
  }

  SetAllowedTargets(allowedTargets) {
    this.fAllowedTargets = allowedTargets;
  }
}
